import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled, { css } from 'styled-components';
import { i as isMobile } from '../../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { s as srOnlyMixin } from '../../theme/style-mixins/srOnly-D3ByQyko.js';

const StyledTable = /*#__PURE__*/styled.table.withConfig({
  componentId: "sc-storm-ui-40027066__sc-30qvhn-0"
})(["width:100%;border:none;border-collapse:collapse;border-spacing:0;", ""], isMobile(css(["&& tr:not(:last-child) td,table tr:last-child td:not(:last-child){border-bottom:unset;}"])));
const StyledCaption = /*#__PURE__*/styled.caption.withConfig({
  componentId: "sc-storm-ui-40027066__sc-30qvhn-1"
})(["", ""], srOnlyMixin);
const KeyValueTable = ({
  caption,
  children,
  ...rest
}) => /*#__PURE__*/React__default.createElement(StyledTable, _extends({
  role: "table",
  cellPadding: "0",
  cellSpacing: "0"
}, rest), /*#__PURE__*/React__default.createElement(StyledCaption, null, caption), /*#__PURE__*/React__default.createElement("tbody", null, children));

export { KeyValueTable as K };
//# sourceMappingURL=KeyValueTable-CZW0kkzu.js.map
